import { ERRORS_BLOCKING_DOE } from './constants';

export function getMaxAttributeValuesLimit(attributesNumber) {
  switch (attributesNumber) {
    case 1:
      return 13;
    case 2:
    case 3:
    case 4:
      return 7;
    default:
      return 6;
  }
}

export function hasExceededMaxAttributeValuesLimit(
  attributeValues,
  maxAttributeValues,
  emptyValues = [],
) {
  return attributeValues.length - emptyValues.length > maxAttributeValues;
}

export function cannotAddAttribute(attributesNumber) {
  return attributesNumber === 6;
}

export function cannotDoeGenerateSettings(allErrors) {
  return allErrors.some(({ errors }) =>
    ERRORS_BLOCKING_DOE.some((errorKey) => errors[errorKey]),
  );
}
